<template>
    <div class="search-result">

        <div class="result-head"  @click="collapsed = !collapsed">
            <div class="toggle-collapse">
                <img :src="collapsed  ? require('@/assets/svg/chevronRight.svg') : require('@/assets/svg/chevronDown.svg')" class="caret"/>
            </div>

        <p v-if="collapsed" v-html="result.highlight" class="result-text-collapsed" ></p>
        </div>
        <!-- <p v-if="!collapsed" v-html="result.highlight" class="result-text" @click="$store.dispatch('setActivePath', result.getParent().getParent().path)"></p> -->
        <p v-if="!collapsed && !searchUpdated " v-html="result.highlight" class="result-text" @click="clickedResult(result)"></p>
        <p v-if="!collapsed && searchUpdated" v-html="result.highlight" class="result-text" @click="clickedResult(result)"></p>

    </div>
</template>

<script>
    import EventBus from "@/assets/js/eventBus.js";
	export default {
		name: 'SearchResult',
		props: {
            result: Object,
            searchUpdated: Boolean
		},
		data() {
			return {
                collapsed: false,
			}
		},
        methods: {        
        removeResultFromList(result){
            this.results.splice(this.results.findIndex(r => r.id == result.id), 1)
        },
        clickedResult(result){
            this.$store.commit('toggleScrollToPath')
            this.$store.dispatch('setActivePath', result.getParent().getParent().path)
         
               this.$nextTick( () => EventBus.$emit('highlightVariantById', result.id))
        }

        },
    
    }
</script>

<style lang="less">
	.search-result{
            a{pointer-events: none;}
    .result-head{
        padding: 5px 10px;
        box-shadow: -0px 2px 4px 0 rgba(0, 0, 0, 0.062);
        display: flex;
        // justify-content: space-between;
        cursor: pointer;


        .result-text-collapsed{
            margin: 0 0 0 10px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 100px;
        }
        .dismiss-item{
            img{
                width: 14px;
            }
        }
    
    }
    
        .result-text{
            margin: 0;
            padding: 5px 10px;
            cursor: pointer;
             word-wrap:break-word;
    }
    .highlight {
    background-color: #ed7c3169;
    }  
        
    }
</style>

